import React from "react";

const priorityClass = (p) => {
  const v = String(p).toLowerCase();
  if (v === "high") return "ai-tag-red";
  if (v === "medium") return "ai-tag-amber";
  if (v === "low") return "ai-tag-green";
  return "ai-tag-gray";
};

const statusClass = (s) => {
  const v = String(s).toLowerCase();
  if (v.includes("complet") || v.includes("closed")) return "ai-tag-green";
  if (v.includes("progress")) return "ai-tag-blue";
  if (v.includes("hold")) return "ai-tag-amber";
  if (v.includes("test")) return "ai-tag-purple";
  if (v.includes("not possible")) return "ai-tag-red";
  return "ai-tag-gray";
};

const percentClass = (n) => {
  const v = Number(n) || 0;
  if (v >= 70) return "ai-tag-green";
  if (v >= 40) return "ai-tag-amber";
  return "ai-tag-red";
};

// Inverse percent (lower is better) — e.g. Idle %.
const percentBadClass = (n) => {
  const v = Number(n) || 0;
  if (v <= 15) return "ai-tag-green";
  if (v <= 30) return "ai-tag-amber";
  return "ai-tag-red";
};

// Render a single cell according to its column "kind" (drives the highlighting).
const renderCell = (col, value) => {
  switch (col.kind) {
    case "name":
      return <span className="ai-rt-name">{value}</span>;
    case "task":
      return (
        <span className="ai-rt-task" title={value}>
          {value}
        </span>
      );
    case "priority":
      return <span className={`ai-tag ${priorityClass(value)}`}>{value}</span>;
    case "status":
      return <span className={`ai-tag ${statusClass(value)}`}>{value}</span>;
    case "percent":
      return (
        <span className={`ai-tag ${percentClass(value)}`}>{value}%</span>
      );
    case "percent-bad":
      return (
        <span className={`ai-tag ${percentBadClass(value)}`}>{value}%</span>
      );
    case "age": {
      const n = Number(value) || 0;
      return (
        <span className={n > 2 ? "ai-age-critical" : "ai-age-ok"}>{n}d</span>
      );
    }
    case "overrun":
      return <span className="ai-tag ai-tag-red">{value}</span>;
    case "count":
      return <span className="ai-rt-count">{value}</span>;
    case "count-alert":
      return (
        <span className={Number(value) > 0 ? "ai-rt-count-alert" : "ai-rt-count"}>
          {value}
        </span>
      );
    case "count-good":
      return <span className="ai-rt-count-good">{value}</span>;
    default:
      return <span>{value}</span>;
  }
};

const ReportView = ({ report }) => {
  if (!report || !Array.isArray(report.rows)) return null;
  const { title, columns, rows, totals } = report;

  return (
    <div className="ai-report">
      <div className="ai-report-title">
        <i className="bi bi-table"></i> {title}
      </div>

      {rows.length === 0 ? (
        <div className="ai-report-empty">No data found.</div>
      ) : (
        <div className="ai-report-scroll">
          <table className="ai-report-table">
            <thead>
              <tr>
                {columns.map((c) => (
                  <th key={c.key}>{c.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  {columns.map((c) => (
                    <td key={c.key} className={`ai-rt-${c.kind || "plain"}`}>
                      {renderCell(c, row[c.key])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            {totals && (
              <tfoot>
                <tr className="ai-rt-total">
                  {columns.map((c, ci) => {
                    const v = totals[c.key];
                    return (
                      <td key={c.key}>
                        {ci === 0 ? (
                          <span className="ai-rt-total-label">{v}</span>
                        ) : v === "" || v == null ? (
                          ""
                        ) : (
                          renderCell(c, v)
                        )}
                      </td>
                    );
                  })}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      )}
    </div>
  );
};

export default ReportView;
